import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonDataTable } from './DataTable.definition';
import { chameleonDataTableBody } from './DataTableBody/DataTableBody.definition';
import { chameleonDataTableCell } from './DataTableCell/DataTableCell.definition';
import { chameleonDataTableHeader } from './DataTableHeader/DataTableHeader.definition';
import { chameleonDataTableRow } from './DataTableRow/DataTableRow.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTable({ prefix }), chameleonDataTableBody({ prefix }), chameleonDataTableCell({ prefix }), chameleonDataTableHeader({ prefix }), chameleonDataTableRow({ prefix }));
}
